import { SerializeFrom } from '@remix-run/node'
import { useLocation } from '@remix-run/react'
import { ReactNode } from 'react'
import { UserDTO } from '~/domain/user/dto/UserDTO'
import { LoginUserDTO } from '~/domain/user/dto/LoginUserDTO'
import { Props as TabProps } from '~/application/components/Tab/useTab'
import { getAvatarUrl } from '~/domain/user/services/UserDTOService'

export interface Props {
  user: SerializeFrom<UserDTO>
  loginUser?: SerializeFrom<LoginUserDTO>
  children: ReactNode
}

export const useUserLayout = (props: Props) => {
  const location = useLocation()
  const { user, children, loginUser } = props
  const tabs: TabProps['items'] = [
    {
      name: '詳細',
      to: `/users/${user.id}`,
      active: location.pathname === `/users/${user.id}`,
    },
    {
      name: '活動報告',
      to: `/users/${user.id}/activities`,
      active: location.pathname === `/users/${user.id}/activities`,
    },
    {
      name: '投稿',
      to: `/users/${user.id}/posts`,
      active: location.pathname === `/users/${user.id}/posts`,
    },
    {
      name: 'スポンサー',
      to: `/users/${user.id}/sponsors`,
      active: location.pathname === `/users/${user.id}/sponsors`,
    },
  ]

  return {
    user,
    loginUser,
    avatar: getAvatarUrl(user),
    tabs,
    children,
  }
}
